import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Votes", -1)
const _hoisted_3 = { class: "buttons" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Add Google Forms Vote")
const _hoisted_5 = { class: "table is-bordered is-striped" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Voting System"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_7 = { class: "content buttons has-addons" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Manage Vote")
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: "/votes/create",
        class: "button is-primary"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createElementVNode("table", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.votes, (vote) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: vote.id
          }, [
            _createElementVNode("td", null, _toDisplayString(vote.id), 1),
            _createElementVNode("td", null, _toDisplayString(vote.name), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.votingSystems.find(value => value.id === vote.votingSystem)?.name), 1),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_router_link, {
                  class: "button is-primary",
                  to: `/vote/${vote.id}`
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("button", {
                  type: "button",
                  class: "button is-danger",
                  onClick: _withModifiers(($event: any) => (_ctx.deleteVote(vote.id)), ["prevent"])
                }, " Delete ", 8, _hoisted_9)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}